import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Position } from "../models/position"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'position/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllPosition(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Position>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllPosition?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewPosition(PositionID?: string): Observable<Array<Position>> {
    return this.httpService.get(this.apiEndpoint + 'viewPosition/' + (PositionID ? PositionID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  savePosition(positions: Position): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'savePosition/', positions).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, PositionId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&PositionId=' + (PositionId ? PositionId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deletePosition(PositionID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deletePosition/' + (PositionID ? PositionID : '00000000-0000-0000-0000-000000000000'), PositionID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(PositionName?: string,PositionId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?PositionName=' + (PositionName ? PositionName : '')+ '&PositionId=' + (PositionId ? PositionId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
